const GAME_ALIASES = {
  "free fire": "free-fire", ff: "free-fire", "free-fire": "free-fire",
  roblox: "roblox",
  "blood strike": "blood-strike", bloodstrike: "blood-strike", "blood-strike": "blood-strike",
  "call of duty": "call-of-duty", "cod mobile": "call-of-duty", codm: "call-of-duty", "call-of-duty": "call-of-duty",
  tiktok: "tiktok", "tik tok": "tiktok",
  "fc mobile": "fc-mobile", fcmobile: "fc-mobile", "fc-mobile": "fc-mobile",
};

export const CELEBRATION_GAMES = {
  "free-fire": { label: "Free Fire", symbol: "💎", resource: "Diamantes", accent: "amber" },
  roblox: { label: "Roblox", symbol: "⬡", resource: "Robux", accent: "sky" },
  "blood-strike": { label: "Blood Strike", symbol: "⬢", resource: "Oro", accent: "red" },
  "call-of-duty": { label: "Call of Duty", symbol: "CP", resource: "CP", accent: "lime" },
  tiktok: { label: "TikTok", symbol: "●", resource: "Monedas", accent: "pink" },
  "fc-mobile": { label: "FC Mobile", symbol: "⚽", resource: "FC Points", accent: "emerald" },
};

export const celebrationOrderItems = (order) => {
  if (Array.isArray(order?.items) && order.items.length) return order.items;
  if (!order?.gameId || !order?.packageId) return [];
  return [{
    id: order.id,
    gameId: order.gameId,
    gameName: order.gameName,
    gameImage: order.gameImage,
    packageId: order.packageId,
    packageName: order.packageName,
    playerId: order.playerId,
  }];
};

export const celebrationGameKey = (item) => {
  const raw = String(item?.gameName || item?.gameId || "").trim().toLowerCase();
  return GAME_ALIASES[raw] || null;
};

export const isDeliveryComplete = (item) => {
  const status = String(item?.provider_item_status || "").toUpperCase();
  if (!status) return true; // El backend ya confirmó el cierre del pedido manual.
  return item?.deliveredManually || item?.deliveredAutomatically || ["CONFIRMED", "COMPLETED"].includes(status);
};

export const hasAllOrderItemsDelivered = (order) => (
  celebrationOrderItems(order).length > 0 && celebrationOrderItems(order).every(isDeliveryComplete)
);

export const isCelebrationEligibleOrder = (order) => (
  order?.status === "Completado"
  && hasAllOrderItemsDelivered(order)
  && celebrationOrderItems(order).some((item) => celebrationGameKey(item))
);

export const celebrationStorageKey = (orderId) => `ag7_celebrated_order_${orderId}`;

export const resolveCelebrationItem = (item, games) => {
  const game = (games || []).find((candidate) => candidate.id === item.gameId) || {};
  const gameKey = celebrationGameKey({ ...item, gameName: item.gameName || game.name });
  const gameConfig = CELEBRATION_GAMES[gameKey] || null;
  // La celebración es un comprobante visual de la orden: no consulta ni usa
  // paquetes actuales, cantidades estructuradas ni nombres del catálogo.
  const packageName = item.packageName || "Paquete entregado";

  return {
    ...item,
    gameName: item.gameName || game.name || "AG7 Store",
    packageName,
    gameKey,
    gameConfig,
    image: item.packageImage || item.gameImage || game.image || "",
  };
};